module.exports = __webpack_public_path__ + "img/logo-orange.64e23664.png";